import { z } from 'zod';

// We're keeping a simple non-relational schema here.
// IRL, you will have a schema for your data models.
export const tagSchema = z.object({
  id: z.number(),
  name: z.string(),
  color: z.string(),
  priority: z.string(),
})

export type Tag = z.infer<typeof tagSchema>;
